/*
 * author: wxq
 * createdTime: 2019/04/11
 * */

/**
 * label                       string                 false               label文字
 * dateApi                     api
 * date                        [{key：'', value: ''}]
 * onChangeSelect              func                                       下拉框改变的回调
 * type                        string[search,arrow]   arrow               下拉需不需要下拉的箭头
 * selectItem                  [{key：'', value: ''}]
 * searchParams
 */
import React, { PureComponent } from 'react';
import { Select, Icon, Spin } from 'antd';
import { getData } from '@util';

const Option = Select.Option;

class CsxSelect extends PureComponent {
  constructor() {
    super();
    this.state = {
      menu: '', // 下拉菜单
      fetching: false,
      selectListData: [],
    };
  }

  componentDidMount() {}

  UNSAFE_componentWillReceiveProps(newProps, newStates) {
    const { data } = this.props;
    if (data && JSON.stringify(data) != JSON.stringify(newProps.data)) {
      const menuObj = this.getMenu(data);
      this.setState({
        ...menuObj,
      });
    }
  }

  getAsyncDate(dateApi) {
    const { searchParams, errMessage } = this.props;
    const reqData = { api: dateApi, errMessage };
    if (searchParams) {
      reqData.searchParams = searchParams;
    }
    getData(reqData).then(data => {
      let result = [];
      if (data.result) {
        if (Array.isArray(data.result)) {
          result = data.result;
        } else {
          result = data.result.list || data.result.data;
        }
      } else if (data.data) {
        if (Array.isArray(data.data)) {
          result = data.data;
        } else {
          result = data.data.data || data.data.list;
        }
      }
      const menuObj = this.getMenu(result);
      this.setState({ ...menuObj, fetching: false, selectListData: data.data || [] });
    });
  }

  // 组合menu菜单
  getMenu(data) {
    const { selectItem } = this.props;
    const menu = data.map((o, i) => (
      <Option key={o[selectItem.key]} value={o[selectItem.key]}>
        {Array.isArray(selectItem.valueKey)
          ? selectItem.valueKey.map((x, y) => o[x]).join('')
          : o[selectItem.valueKey]}
      </Option>
    ));
    return {
      menu,
    };
  }

  // 选中下拉框的回调
  onMenuItemClick(key, valueObj) {
    // this.props.onChangeSelect({
    //   value: valueObj.props.value,
    //   children: valueObj.props.children
    // })
    const jud =
      this.props.selectItem &&
      Array.isArray(this.props.selectItem.valueKey) &&
      this.props.selectItem.valueKey.length > 1
        ? true
        : false;
    this.props.onChangeSelect({
      value: valueObj.props.value,
      children: jud
        ? valueObj.props.children.replace(valueObj.props.value, '')
        : valueObj.props.children,
      selectListData: this.state.selectListData,
    });
  }

  // 聚焦的回调
  handleFocus = () => {
    const { dateApi, data } = this.props;
    if (data) {
      const menuObj = this.getMenu(data);
      this.setState({
        ...menuObj,
      });
    } else {
      dateApi && this.getAsyncDate(dateApi);
    }
  };

  render() {
    const {
      label,
      type,
      selectItem,
      placeholder,
      style,
      antd,
      showBoth,
      allowClear,
      defaultValue,
      require,
      boxWidth,
      labelWidth,
    } = this.props;
    const { menu, fetching } = this.state;
    if (!selectItem.data) {
      selectItem.data = {};
    }
    return (
      <div className="commonInput">
        {label && (
          <label
            style={{ flex: labelWidth ? labelWidth : '0 0 120px' }}
            className={require ? 'show_required' : ''}>
            {label}：
          </label>
        )}
        <div className="box" style={{ maxWidth: boxWidth ? boxWidth : '70%' }}>
          {type && (
            <div className="icon-box">
              <Icon type={type} />
            </div>
          )}
          <Select
            allowClear={allowClear || true}
            defaultValue={defaultValue || ''}
            showSearch
            {...antd}
            style={style}
            showArrow={type ? false : true}
            dropdownMatchSelectWidth={false}
            placeholder={placeholder || '请选择'}
            notFoundContent={fetching ? <Spin size="small" /> : null}
            value={
              showBoth
                ? selectItem.data.children
                  ? `${selectItem.data.value}${selectItem.data.children}`
                  : undefined
                : selectItem.data.children
            }
            optionFilterProp="children"
            getPopupContainer={triggerNode => triggerNode.parentNode}
            onSelect={(key, valueObj) => {
              this.onMenuItemClick(key, valueObj);
            }}
            onChange={value => {
              if (value === null || value === undefined || value === '') {
                this.props.onChangeSelect({});
              }
            }}
            onFocus={this.handleFocus}
            // onBlur={handleBlur}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }>
            {menu}
          </Select>
        </div>
      </div>
    );
  }
}

export default CsxSelect;
